/* eslint-disable no-undef */

import Vue from 'vue'
import api from '../api'

export const USER_SIGNIN = 'USER_SIGNIN' // 登录成功
export const USER_SIGNOUT = 'USER_SIGNOUT' // 退出登录
export const WRITE_USER_INFO = 'WRITE_USER_INFO' // 微信登录后写入用户信息
export const UPDATE_PATIENT_INFO = 'UPDATE_PATIENT_INFO' // 更新病人信息
export default {
  state: JSON.parse(sessionStorage.getItem('user')) || {},
  mutations: {
    [USER_SIGNIN] (state, user) {
      sessionStorage.setItem('user', JSON.stringify(user))
      Object.assign(state, user)
    },
    [USER_SIGNOUT] (state) {
      sessionStorage.removeItem('user')
      Object.keys(state).forEach(k => Vue.delete(state, k))
    },
    [UPDATE_PATIENT_INFO] (state, data) {
      let user = JSON.parse(JSON.stringify(state))
      user.address = data.patientBed
      user.patientIndicateTags = data.patientIndicateTags
      user.bedPatientName = data.patientName
      user.patientSpecialDiet = data.patientSpecialDiet
      sessionStorage.setItem('user', JSON.stringify(user))
      Object.assign(state, user)
    }
  },
  actions: {
    [USER_SIGNIN] ({
      commit
    }, user) {
      return new Promise(function (resolve, reject) {
        api.login(user).then((data) => {
          data.hallId = 13
          commit(USER_SIGNIN, data)
          resolve()
        }, (data) => {
          commit(USER_SIGNOUT)
          reject(data)
        })
      })
    },
    [USER_SIGNOUT] ({
      commit
    }) {
      commit(USER_SIGNOUT)
    },
    [WRITE_USER_INFO] ({
      commit
    }, user) {
      commit(USER_SIGNIN, user)
    },
    [UPDATE_PATIENT_INFO] ({
      commit,
      state
    }, patientNo) {
      return new Promise(function (resolve, reject) {
        api.getPatientInfo(state, patientNo).then((data) => {
          commit(UPDATE_PATIENT_INFO, data)
          resolve()
        }, (data) => {
          reject(data)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user.js